import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, ICliente } from './interface/apiInterface';
import { IClientsData, IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  clientsIsLoaded: false,
  partnersIsLoaded: false,
  date: {
    start: '',
    end: '',
  },
  clientsList: {
    clients: [],
    totalBalance: 0,
  },
  partnersList: [],
};

export const getListOfClientsAndBalances = createAction<any>(
  '@clientsApp/GET_LIST_OF_CLIENTS_AND_BALANCES'
);
export const getListOfPartners = createAction<any>(
  '@clientsApp/GET_LIST_OF_PARTNERS'
);
export const loadingClientsList = createAction('@clientsApp/LOADING_RESPONSE');
export const eraserList = createAction('@clientsApp/ERASER_CLIENTS_LIST');
export const getErrorList = createAction('@clientsApp/GET_ERROR_LIST');
export const logoutClientsApp = createAction('@clientsApp/LOGOUT_CLIENTS_APP');

function checkArray(props: any) {
  if (props === undefined) {
    return [];
  }
  return props;
}

const clientsAppReducer = createReducer(INITIAL_STATE, {
  [getListOfClientsAndBalances.type]: (state, action: IAction) => ({
    ...state,
    date: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    clientsList: {
      clients: checkArray(action.payload.clientes).map((cliente: ICliente) => {
        const data: IClientsData = {
          account: cliente.cliente.conta,
          accountFormat: cliente.cliente.formato_conta,
          accountType: cliente.cliente.tipo_conta,
          agency: cliente.cliente.agencia,
          boletoFare: cliente.cliente.tarifa_boleto,
          cel: cliente.cliente.celular,
          cbo: cliente.cliente.cbo,
          cnae: cliente.cliente.cnae,
          fins_lucrativo: cliente.cliente.fins_lucrativo,
          cep: cliente.cliente.cep,
          city: cliente.cliente.cidade,
          clicksignKey: cliente.cliente.key_clicksign,
          closedAccount: cliente.cliente.conta_encerrada,
          companyName: cliente.cliente.nome_razaoSocial,
          complement: cliente.cliente.complemento,
          country: cliente.cliente.uf,
          cpfCnpj: cliente.cliente.cpf_cnpj,
          createdAt: cliente.cliente.created_at,
          digit: cliente.cliente.digito,
          district: cliente.cliente.bairro,
          email: cliente.cliente.email,
          id: cliente.cliente.id,
          legalEntity: cliente.cliente.tipo_pessoa,
          monthlyFare: cliente.cliente.tarifa_mensal,
          number: cliente.cliente.numero,
          partnerId: cliente.cliente.id_parceiro,
          publicPlace: cliente.cliente.logradouro,
          status: cliente.cliente.status,
          birthday: cliente.cliente.data_nascimento,
          tedFare: cliente.cliente.tarifa_ted,
          updatedAt: cliente.cliente.updated_at,
          payrollIdPartner: cliente.cliente.id_parceiro_consignada,
          scrowIdPartner: cliente.cliente.id_parceiro_escrow,
          balance: cliente.saldo,
        };
        return data;
      }),
      totalBalance: action.payload.saldoTotal,
    },
    clientsIsLoaded: true,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
  }),
  [getListOfPartners.type]: (state, action) => ({
    ...state,
    partnersList: action.payload,
    partnersIsLoaded: true,
  }),
  [eraserList.type]: (state) => ({
    ...state,
    clientsList: { clients: [], totalBalance: 0 },
    clientsIsLoaded: false,
    partnersIsLoaded: false,
  }),
  [getErrorList.type]: (state) => ({
    ...state,
    clientsList: { clients: [], totalBalance: 0 },
    clientsIsLoaded: false,
    partnersIsLoaded: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [loadingClientsList.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [logoutClientsApp.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    clientsIsLoaded: false,
    partnersIsLoaded: false,
    clientsList: {
      clients: [],
      totalBalance: 0,
    },
    partnersList: [],
  }),
});

export default clientsAppReducer;
